<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="cancelOrder()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-searchbar [(ngModel)]="queryText" placeholder="Search Orders"></ion-searchbar>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-refresher slot="fixed" (ionRefresh)="fetchDocuments($event)">
        <ion-refresher-content
                pullingIcon="arrow-dropdown"
                pullingText="Pull to refresh"
                refreshingSpinner="circles"
                refreshingText="Fetching Documents...">
        </ion-refresher-content>
    </ion-refresher>
    <ion-list no-padding>
        <ion-item *ngFor="let ord of ordersList | filterDocs: queryText" (click)="selectDocument(ord)">
            <ion-label>
                <p>{{ ord.documentNumber }} - {{ ord.customer.name }}</p>
                <p>{{ ord.creationDate | date: 'dd/MM/yyyy' }}</p>
                <p *ngFor="let line of ord.detailLines">{{line.qty}} x {{line.description}}</p>
            </ion-label>
        </ion-item>
    </ion-list>

</ion-content>
